import React from 'react';
import * as Styled from './styles';

export const applyCustomAmpersands = (content) => {
  var bits = content.split('&');
  return bits.slice(1).reduce(function (xs, x, i) {
    var ampersand = <Styled.CustomAmpersand>&amp;</Styled.CustomAmpersand>
    return xs.concat([ampersand, x]);
  }, [bits[0]]);
}